import helpers from "./helpers";

export default {
    setIsCreateAdministratorPage(state, data) {
        state.isCreateAdministratorPage = data;
    },
    resetAdministratorDataForm(state) {
        state.administratorDataForm = helpers.administratorFormData(state);
    },
    resetAdministratorPasswordForm(state) {
        state.administratorPasswordForm = helpers.administratorPasswordForm();
    },
    setFormEmail(state, data) {
        state.administratorDataForm.email = data;
    },
    setFormPhoneNumber(state, data) {
        state.administratorDataForm.phoneNumber = data;
    },
    setFormClock24Hours(state, data) {
        state.administratorDataForm.clock24Hours = data;
    },
    setFormLocale(state, data) {
        state.administratorDataForm.locale = data;
    },
    setFormTenantId(state, data) {
        state.administratorDataForm.tenantId = data;
    },
    setFormTimezone(state, data) {
        state.administratorDataForm.timezone = data;
    },
    setFormDateFormat(state, data) {
        state.administratorDataForm.dateFormat = data;
    },
    setFormPlainPassword(state, data) {
        state.administratorPasswordForm.plainPassword = data;
    },
    setFormRepeatedPassword(state, data) {
        state.administratorPasswordForm.repeatedPassword = data;
    },
    setFormEnabled(state, data) {
        state.administratorDataForm.enabled = data;
    },
    setFormLocked(state, data) {
        state.administratorDataForm.locked = data;
    },
    setAdministrators(state, data) {
        state.isBusy = false;
        state.administrators = data;
    },
    setAdministrator(state, data) {
        state.administratorDetails = data;
    },
    setTotalCounts(state, data) {
        state.totalCount = data;
    },
    setBusy(state, data) {
        state.isBusy = data;
    },
    setRoles(state, data) {
        state.roles = data;
    },
    setAvailableRoles(state, data) {
        state.availableRoles = data;
    },
    setSelectedRoles(state, data) {
        state.selectedRoles = data;
    },
    setGroups(state, data) {
        state.groups = data;
    },
    setAvailableGroups(state, data) {
        state.availableGroups = data;
    },
    setSelectedGroups(state, data) {
        state.selectedGroups = data;
    },
    setAdministratorDataIsLoading(state, data) {
        state.administratorDataIsLoading = data;
    },
    setAdministratorDetailsGroupsWithRoles(state, data) {
        state.administratorDetailsGroupsWithRoles = data;
    },
    setTenants(state, data) {
        state.tenants = data;
    }
}
